<template ref="table">
  <div class="l-content">
    <div class="row">
      <div class="col-xs-16 col-xs-offset-1 col-sm-14 col-sm-offset-2">
          <div class="se-table__above">
            <slot name="above"></slot>
          </div>
          <div class="se-table" :class="'se-table--' + columns">
            <slot></slot>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Table',
  props: ['columnHeader', 'columns'],
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../scss/vars';
  .se-table {
    display: flex;
    flex-flow: row wrap;
    margin-right: 0;
    border: none;
    @media (min-width: 768px) {
      // border: 0.5px solid $table-border;
    }
    &__above {
      h2 {
        color: $grey;
        margin-bottom: 24px;
      }
      margin-bottom: 50px;
    }
    &--3 {
      .se-tablecell {
        @media (min-width: 768px) {
          width: 33.333%;
        }
      }
    }
    &--2 {
      .se-tablecell {
        @media (min-width: 768px) {
          width: 50%;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Table.vue